import React, { useCallback, useState } from 'react';
import { RefreshCw } from 'lucide-react';

type RefreshButtonProps = {
    onRefresh: () => Promise<any> | void;
    /** Override the default button class */
    className?: string;
    /** Icon pixel size (default 15) */
    iconSize?: number;
    /** Whether to show the "Refresh" label next to the icon */
    showLabel?: boolean;
};

const RefreshButton = ({ onRefresh, className = 'btn btn-ghost text-sm', iconSize = 15, showLabel = true }: RefreshButtonProps) => {
    const [spinning, setSpinning] = useState(false);

    const handleClick = useCallback(async () => {
        setSpinning(true);
        try {
            await onRefresh();
        } finally {
            // keep spinning for a minimum duration so the user always sees the feedback
            setTimeout(() => setSpinning(false), 500);
        }
    }, [onRefresh]);

    return (
        <button className={className} onClick={handleClick} disabled={spinning}>
            <RefreshCw size={iconSize} className={spinning ? 'animate-spin' : ''} />
            {showLabel && ' Refresh'}
        </button>
    );
};

export default RefreshButton;
